export default class TimeConstants {
  public static readonly SNACKBAR_ALERT_DURATION = 6000;
  public static readonly SNACKBAR_ALERT_DURATION_SUBMIT_RESPONSE = 100000;
}
